import React, { useState } from 'react';
import { confirmSignUp, resendSignUpCode } from 'aws-amplify/auth';
import { useNavigate, useLocation } from 'react-router-dom';
import './mfaVerification.css'; // Reusing MFA styles

const VerifyEmailPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || '';

  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [resending, setResending] = useState(false);

  const handleConfirm = async () => {
    setError('');
    setLoading(true);
    try {
      await confirmSignUp({ username: email, confirmationCode: code });
      navigate('/glue-dashboard');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    setResending(true);
    try {
      await resendSignUpCode({ username: email });
    } catch (err) {
      setError(err.message);
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="mfa-container">
      <div className="mfa-box">
        <h2 className="mfa-subtitle">Verify your email</h2>
        <h1 className="mfa-title">Check your inbox</h1>
        <p className="mfa-desc">We’ve sent a 6-digit verification code to <strong>{email}</strong>.</p>

        <input
          className="mfa-input"
          type="text"
          placeholder="Enter code"
          value={code}
          onChange={(e) => setCode(e.target.value)}
        />

        {error && <div className="mfa-error">{error}</div>}

        <button
          className="mfa-button"
          onClick={handleConfirm}
          disabled={loading}
        >
          {loading ? 'Verifying...' : 'Verify Email'}
        </button>

        <button
          className="mfa-resend"
          onClick={handleResend}
          disabled={resending}
        >
          {resending ? 'Resending...' : 'Resend Code'}
        </button>
      </div>
    </div>
  );
};

export default VerifyEmailPage;
